import { render, staticRenderFns } from "./KunyePage.vue?vue&type=template&id=e40e8d78&scoped=true&"
import script from "./KunyePage.vue?vue&type=script&lang=js&"
export * from "./KunyePage.vue?vue&type=script&lang=js&"
import style0 from "./KunyePage.vue?vue&type=style&index=0&id=e40e8d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40e8d78",
  null
  
)

export default component.exports